import { atom } from 'jotai';
import { RESET } from 'jotai/utils';

export const atomWithSessionStorage = <T>(key: string, initialValue: T) => {
  const getInitialValue = () => {
    const item = sessionStorage.getItem(key);
    if (item !== null) {
      return JSON.parse(item) as T;
    }
    return initialValue;
  };
  const baseAtom = atom(getInitialValue());
  const derivedAtom = atom(
    (get) => get(baseAtom),
    (get, set, update) => {
      let nextValue;
      if (typeof update === 'function') {
        nextValue = update(get(baseAtom));
      } else if (update === RESET) {
        nextValue = initialValue;
      } else {
        nextValue = update;
      }

      set(baseAtom, nextValue);
      sessionStorage.setItem(key, JSON.stringify(nextValue));
    },
  );
  return derivedAtom;
};
